interface ErrorFallbackProps {
  error?: unknown;
  resetError?: () => void;
}

const ErrorFallback = ({ error, resetError }: ErrorFallbackProps) => {
  const handleRetry = () => {
    if (resetError) {
      resetError();
    } else {
      window.location.reload();
    }
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center px-2 py-8 sm:px-6">
      <div className="flex w-full max-w-xs flex-col items-center">
        {/* Error Title */}
        <h1 className="mb-3 text-center text-xl font-bold text-content-base">Something went wrong</h1>

        {/* Error Message */}
        <p className="mb-8 text-center text-sm text-content-soft">
          We&apos;re sorry, but something unexpected happened. Please try again.
        </p>

        {/* Action Buttons */}
        <div className="flex w-full flex-col gap-3">
          <button
            onClick={handleRetry}
            className="w-full rounded-lg bg-brand-600 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-700 active:bg-brand-800"
          >
            Try Again
          </button>

          <button
            onClick={handleGoHome}
            className="w-full rounded-lg border border-stroke-base bg-transparent px-4 py-3 text-sm font-semibold text-content-base transition-colors hover:bg-stroke-soft active:bg-stroke-base"
          >
            Go to Home
          </button>
        </div>

        {/* Error Details (Development Only) */}
        {Boolean(error) && process.env.NODE_ENV === "development" && (
          <details className="mt-6 w-full max-w-xs">
            <summary className="cursor-pointer text-xs text-content-soft">Error Details</summary>
            <pre className="mt-2 whitespace-pre-wrap rounded bg-stroke-soft p-3 text-xs text-content-base">
              {error instanceof Error ? error.message : String(error)}
              {error instanceof Error && error.stack && `\n\n${error.stack}`}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;
